import { createFileRoute, redirect } from '@tanstack/react-router';
import { requirePermissions } from '@/shared/utils';

export const Route = createFileRoute('/_app/quotes/products/new/')({
  component: NewQuotePageComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['policies.quotes.write']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function NewQuotePageComponent() {
  // vazio de propósito: o layout __root renderiza o formulário e persiste o estado
  return null;
}
